/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect, useContext } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PhoneIcon from '@mui/icons-material/Phone';
import SmsIcon from '@mui/icons-material/Sms';
import { useForm, Controller } from 'react-hook-form';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Swal from 'sweetalert2';
import { getStorage, setStorage } from '../utils/functions/localstorage';
import { PassportAuth } from '../contexts/AuthContext';
import Loading from '../components/Loading';
import inetlogo from '../assets/images/Inet_logo.png'
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import AuthenticateApi from '../service/auth.api';
import TermsConsentDialog from '../components/dialogs/admin/TermsConsentDialog';

function LoginAdmin() {
  const { handleAdminSignin } = useContext(PassportAuth);
  const navigate = useNavigate();
  const { register, handleSubmit, control } = useForm({
    defaultValues: {
      typeTax: 'citizen',
    },
  });

  const [isLoading, setIsLoading] = useState(false);
  const [hasToken, setHasToken] = useState(false);
  const [token, setToken] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [termConsent, setTermConsent] = useState();
  const [isAdminApproveConsent, setIsAdminApproveConsent] = useState(false);
  const [isConsentDialog, setIsConsentDialog] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  useEffect(() => {
    setHasToken(!!getStorage('token'));
    return () => {};
  }, []);

  const methos = {
    notify: (err) => {
      let messageAlert = '';
      switch (err) {
        case 'Company not found':
          messageAlert = 'เลขประจำตัวของบริษัทไม่ถูกต้อง';
          break;
        case 'Invalid Username or Password':
          messageAlert = 'ชื่อผู้ใช้ หรือรหัสผ่านไม่ถูกต้อง';
          break;
        case 'Invalid role admin':
          messageAlert = 'ท่านยังไม่ได้รับสิทธิ์ในการเป็นผู้ดูแลระบบ';
          break;
        case 'Not fond member business OneId':
          messageAlert = 'ไม่พบข้อมูลบริษัท';
          break;
        default:
          break;
      }
      Swal.fire({
        title: 'เข้าสู่ระบบไม่สำเร็จ',
        text: `${messageAlert}`,
        icon: 'error',
        confirmButtonColor: '#4FA893',
        confirmButtonText: 'ตกลง',
      });
    },
  };

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      // REMOVE SPACE
      const email = data.email.replace(/\s+/g, '');
      const password = data.password.replace(/\s+/g, '');
      const taxId = data.taxId.replace(/\s+/g, '');
      const { typeTax } = data;
      const resp = await handleAdminSignin(email, password, taxId, typeTax);
      const tokenData = resp?.token;
      setToken(tokenData);

      if (!!tokenData) {
        await handleOpenDialogConsent(tokenData);
        setIsLoading(false);
      }
    } catch (error) {
      methos.notify(error.error.message);
      setIsLoading(false);
    }
  };

  const handleOpenDialogConsent = async (tokenData) => {
    try {
      const resp = await AuthenticateApi.getApproveConsentApi(tokenData);
      setTermConsent(resp);
      setIsAdminApproveConsent(resp?.isAdminApproveConsent);

      if (!resp?.isAdminApproveConsent) {
        setIsConsentDialog(true);
      } else {
        await setStorage('token', tokenData);
        navigate('/');
        window.location.reload();
      }
    } catch (error) {
      console.log("error :", error);
    }
  }

  return hasToken && isAdminApproveConsent ? (
    <Navigate to="/" />
  ) : (
    <div
      style={{
        // background: '#4FA893',
        background: 'linear-gradient(to left top, #bcfbc5, #aff5c3, #a3eec0, #96e8be, #8ae1bc, #81dab8, #78d3b3, #6fccaf, #67c3a8, #5fbaa1, #57b19a, #4fa893)',
      }}
    >
      <Loading isLoading={isLoading} />
      {/* <CssBaseline /> */}
      <div className="flex h-screen">
        <div className="m-auto">
          <div className="px-6 py-4">
            <Card
              sx={{
                borderRadius: 2,
                padding: 2,
                position: 'relative',
                boxShadow:
                  '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
              }}
            >
              <Box
                sx={{
                  maxWidth: 400,
                  padding: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <img src={inetlogo} alt="inet logo" className='w-[140px] mb-6'/>
                <span className='mb-2'>ยินดีต้อนรับเข้าสู่ระบบ</span>
                <Typography component="h1" variant="h5" sx={{ fontWeight: 'medium' }} className='text-[#4FA893]'>
                  Bill Payment Lite
                </Typography>

                <Box noValidate sx={{ mt: 1 }}>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      id="email"
                      label="อีเมลล์"
                      placeholder='อีเมลล์'
                      {...register('email')}
                      name="email"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PersonIcon />
                          </InputAdornment>
                        ),
                      }}
                      autoComplete="email"
                      autoFocus
                    />
                    <FormControl variant="outlined" required fullWidth sx={{ mt: 1 }}>
                      <InputLabel htmlFor="outlined-adornment-password">
                        รหัสผ่าน
                      </InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-password"
                        {...register('password')}
                        type={showPassword ? 'text' : 'password'}
                        placeholder='รหัสผ่าน'
                        startAdornment={
                          <InputAdornment position="start">
                            <LockIcon />
                          </InputAdornment>
                        }
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Password"
                      />
                    </FormControl>
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SupervisedUserCircleIcon />
                          </InputAdornment>
                        ),
                      }}
                      name="taxId"
                      placeholder='เลขประจำตัวผู้เสียภาษี'
                      label="เลขประจำตัวผู้เสียภาษี"
                      {...register('taxId')}
                      id="taxId"
                      autoComplete="tax-id"
                    />

                    <Controller
                      rules={{ required: true }}
                      control={control}
                      name="typeTax"
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                        >
                          <FormControlLabel
                            value="citizen"
                            control={<Radio />}
                            label="Citizen"
                            sx={{ mr: 7 }}
                          />
                          <FormControlLabel
                            value="business"
                            control={<Radio />}
                            label="Business"
                          />
                        </RadioGroup>
                      )}
                    />

                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      sx={{ mt: 3, mb: 2, borderRadius: 5, textTransform: 'none' }}
                    >
                      <div className="text-white">
                        เข้าสู่ระบบ
                      </div>
                    </Button>
                  </form>
                  <div>
                    <Grid container spacing={2} columns={16}>
                      <Grid item xs={6}>
                        <Link
                          href="https://one.th/type_forgot_password"
                          variant="body2"
                        >
                          <div className='text-blue-500'>
                            ลืมรหัสผ่าน?
                          </div>
                        </Link>
                      </Grid>
                      <Grid item xs={10}>
                        <span className='text-sm text-[#4FA893]'> ยังไม่มีบัญชีใช่หรือไม่? </span>
                        <Link href="https://one.th/register" variant="body2">
                        <span className='text-blue-500'> ลงทะเบียนที่นี่ </span>
                        </Link>
                      </Grid>
                    </Grid>
                  </div>
                </Box>
              </Box>
            </Card>
          </div>
        </div>
      </div>
      
      <TermsConsentDialog
        open={isConsentDialog}
        onClose={() => setIsConsentDialog(false)}
        termConsent={termConsent}
        token={token}
      />
    </div>
  );
}

export default LoginAdmin;
